



























import {Vue, Component, Prop, Inject } from 'vue-property-decorator';

import { DateTime } from 'luxon';
import { MScheduleSlot } from '@api/models/meetings-schedule/MeetingsScheduleSlot';
import { MScheduleService } from '@share/meetings-schedule/MeetingsScheduleService';
import { UserProfile } from '@api/models/UserProfile';
import { MeetingsSchedule } from '@api/models/meetings-schedule/MeetingsSchedule';
import { SlotInteractionServiceInterface } from '@share/meetings-schedule/helpers/SlotInteractionService';
import { UserRole } from '@share/meetings-schedule/types/UserRole';
import { Modal } from '@common/Modal';

import UserSelect from "@share/common/user-select/UserSelect.vue";
import MainTable from '@share/meetings-schedule/components/tables/MainTable.vue';
import StatefullSlot from '@share/meetings-schedule/components/meeting-slot/StatefullSlot.vue';

@Component({
    name: 'TableSlotContainer',
    components: { StatefullSlot, UserSelect }
})
export default class TableSlotContainer extends Vue {

    @Prop() scheduleService: MScheduleService;
    @Prop() slotService: SlotInteractionServiceInterface;

    @Prop() ownProfile: UserProfile;

    @Prop({ required: true }) schedule: MeetingsSchedule;
    @Prop({ default: [] }) slots: MScheduleSlot[];
    @Prop({ required: true }) timeFrame: DateTime;

    rect: DOMRect | null = null

    targetSlot: MScheduleSlot | null = null;

    isShowUserSelect = false;
    userSelectStyle = "";
    tailPosition = { x: 7, y: 0};

    selectUser(profile: UserProfile) {
        if(this.targetSlot && profile.userId) {
            this.slotService.book(this.targetSlot, profile.userId);
            this.isShowUserSelect = false;
        }
    }

    showUserSelect({ element, event }: {element: HTMLElement; event: MouseEvent }, slot: MScheduleSlot) {
        if(this.isShowUserSelect) {
            event.stopPropagation();
        }
        else {
            this.isShowUserSelect = true;
        }

        this.targetSlot = slot;

        this.userSelectStyle = `top: ${element.offsetTop}px; left: ${0}px`
        this.tailPosition = { x: 0, y: 0 };

        this.$nextTick(() => {
            this.setUserSelectPosition(element)
        })
    }

    closeUserSelect() {
        this.isShowUserSelect = false;
        this.targetSlot = null;
        this.userSelectStyle = "";
    }

    setUserSelectPosition(element: HTMLElement) {
        const container = (this.$refs["userSelect"] as UserSelect | undefined)?.$el as HTMLElement | undefined;

        if(container) {
            const toTheLeftEdge = element.offsetLeft;
            const offsetTop = element.offsetTop;

            const elementRect = element.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            const containerWidth = containerRect.width;

            let top, left, tailPositionX, tailPositionY;

            // Y
            if(elementRect.y + containerRect.height + 25 > window.innerHeight) {
                top = offsetTop - containerRect.height - 11;
                tailPositionY = containerRect.height - 9;
            }
            else {
                top = offsetTop + element.offsetHeight;
                tailPositionY = -7;
            }

            // X
            if(toTheLeftEdge > containerWidth - 40) {
                left = (this.$el as HTMLElement).offsetWidth - containerWidth - 20;
                tailPositionX = containerWidth - Math.abs((this.$el as HTMLElement).offsetWidth - toTheLeftEdge) + (element.offsetWidth / 2) + 11;
            }
            else {
                left = 0;
                tailPositionX = toTheLeftEdge + (element.offsetWidth / 2) - 11;
            }

            this.userSelectStyle = `top: ${top}px; left: ${left}px`
            this.tailPosition = { x: tailPositionX, y: tailPositionY };
        }
    }

    async slotClick(schedule: MeetingsSchedule, slot: MScheduleSlot) {
        //запрещать только если нет ownerId

        const role: UserRole = this.scheduleService.getRole(schedule.userIds);

        //ADMIN:
        if(role === UserRole.admin) {

            if(slot.isNotAvailable || !slot.ownerId) {
                // 🔴  => 🟢
                this.slotService.toggleAvaliable(slot, this.userId);
            }
            else if(slot.ownerId && slot.ownerId !== this.userId) {
                // 🟡  => 🟢
                const confirm = await this.doConfirm();

                if(confirm && confirm !== "close") {
                    this.slotService.cancelBooking(slot);
                }
            }
        }

        //SPEAKER:
        if(role === UserRole.speaker) {
            // 🔴  => 🟢
            // 🟢  => 🔴
            this.slotService.toggleAvaliable(slot);
        }

        //MEMBER:
        if(role === UserRole.member) {
            //после записи все слоты для участника должны быть заблокированы +

            // 🟡  => 🟢
            if(slot.ownerId && slot.ownerId === this.userId) {
                const confirm = await this.doConfirm();

                if(confirm && confirm !== "close") {
                    slot.isNotAvailable = false;

                    this.slotService.cancelBooking(slot);
                    //снятие записи
                }
            }
            // 🟢  => 🟡
            else if(!slot.isNotAvailable && !slot.ownerId) {

                const bookedSlot = await this.slotService.book(slot);

                if(bookedSlot) {
                    Vue.set(slot, "ownerIds", [this.userId]);
                }

                // TODO: добавлять профиль только когда его нет
                this.scheduleService.setOwnProfile();
            }
        }
    }

    async doConfirm() {
        const modal = new Modal({
            contentText: this.$t('common.cancelReocrdingConfirm').toString(),
            buttons: [
                {
                    text: this.$t('common.yes').toString(),
                    class: 'is-green is-middle',
                    returnValue: true
                },
                {
                    text: this.$t('common.no').toString(),
                    class: 'is-red is-middle',
                    returnValue: false
                },
            ]
        });

        return await modal.showConfirm()
    }

    timeIsOver(slot: MScheduleSlot) {
        if(typeof slot.beginAt === "string") {return false;}

        if(this.isAdminOrSpeaker && slot.ownerId) {
            return false;
        }

        return DateTime.local().plus({ minutes: this.minutesBeforeBookingClose }) > slot.beginAt;
    }

    private setAccesToSchedule(scheduleId: string, slotId: string) {
        this.scheduleService.setAccesToSchedule(scheduleId, slotId)
    }

    private getKey(slot: MScheduleSlot) {
        (slot.beginAt as DateTime).toMillis()
    }

    /**
     * Профиль виден только когда слот доступен и только свой профиль если пользователь не админ или не спикер
     */
    private getSlotProfile(userId: number | undefined | null, isNotAvailable: boolean): UserProfile | undefined {

        if(isNotAvailable || (!this.isAdminOrSpeaker && userId !== this.userId) ) {
            return undefined;
        }

        return userId ? this.profiles?.get(userId) : undefined;
    }

    private get isAdminOrSpeaker() {
        return this.isAdmin || this.isSpeaker
    }

    private get isAdmin(): boolean {
        return this.$store.getters['isAdmin'];
    }

    private get isSpeaker() {
        return this.scheduleService.getRole(this.schedule.userIds) === UserRole.speaker;
    }

    private get userId() {
        return this.$store.state.session.userId;
    }

    private get minutesBeforeBookingClose(): number {
        return this.$store.getters['events/selectedEventViewParam']('meetingsSchedule', null)?.minutesBeforeBookingClose || 0;
    }

    private get accessTable() {
        return this.scheduleService.accessTable;
    }

    private get profiles() {
        return this.scheduleService.profiles;
    }
}

